import React from "react";
import * as Sentry from "@sentry/react";
import { Link, useRouteError } from "react-router";

export function ErrorBoundary() {
  const error = useRouteError() as Error;

  React.useEffect(() => {
    if (!error) {
      return;
    }

    console.error("error boundary: ", error);
    Sentry.captureException(error);
  }, [error]);

  return (
    <div className="flex min-h-dvh w-full items-center justify-center bg-background px-4 py-10 text-center text-foreground">
      <span className="text-lg font-label text-balance">
        An error has occurred, try refreshing the page or{" "}
        <Link
          to="/"
          className="font-normal underline underline-offset-3 hover:text-primary focus-visible:rounded-sm focus-visible:ring-3 focus-visible:ring-ring/50 focus-visible:outline-none"
        >
          navigate to the home page
        </Link>
      </span>
    </div>
  );
}
